import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-074eb52c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "course-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "bottom"
};
const _hoisted_5 = {
  class: "course-teacher text-overflow"
};
const _hoisted_6 = {
  class: "teacher-photo"
};
const _hoisted_7 = {
  class: "photo-item"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "name text-overflow"
};
const _hoisted_10 = {
  class: "course-name text-overflow ml",
  id: "courseName"
};
const _hoisted_11 = {
  class: "teacher-info ml fs fw"
};
const _hoisted_12 = {
  class: "text-overflow mt fs fw"
};
const _hoisted_13 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $props.courseData.avatar || require('@/assets/images/common/teacher_icon.png'),
    alt: ""
  }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString($props.courseData.lecturer), 1)])])]), _createElementVNode("div", _hoisted_10, _toDisplayString($props.courseData.course_name), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, [_createTextVNode(_toDisplayString($props.courseData.organ_name) + " ", 1), $props.courseData.organ_name && $props.courseData.post ? (_openBlock(), _createElementBlock("span", _hoisted_13, "-")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($props.courseData.post), 1)])])])])]);
}